module.exports = __webpack_public_path__ + "img/packs.1457eaec.png";